import { render } from "./AutoLogin.vue?vue&type=template&id=6107f95a"
import script from "./AutoLogin.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./AutoLogin.vue?vue&type=script&charset=utf-8&lang=js"
script.render = render

export default script